// @ts-nocheck
import { FieldsDictionary } from "@store/Framework/Features/FieldDefinitionBuilder/FieldDefinitionBuilderTypes";

const typographyFieldDictionary: FieldsDictionary = {
    titleStyle: {
        name: "titleStyle",
        displayName: "Title Style",
        editorTemplate: "DropDownField",
        options: [
            { displayName: "Primary Header", value: "headerPrimary" },
            { displayName: "Secondary Header", value: "headerSecondary" },
            { displayName: "Tertiary Header", value: "headerTertiary" },
            { displayName: "H1", value: "h1" },
            { displayName: "H2", value: "h2" },
            { displayName: "H3", value: "h3" },
            { displayName: "H4", value: "h4" },
            { displayName: "H5", value: "h5" },
            { displayName: "H6", value: "h6" },
        ],
        defaultValue: "h2",
        fieldType: "General",
    },
    titleType: {
        name: "titleType",
        displayName: "Title Type",
        editorTemplate: "DropDownField",
        options: [
            { displayName: "H1", value: "h1" },
            { displayName: "H2", value: "h2" },
            { displayName: "H3", value: "h3" },
            { displayName: "H4", value: "h4" },
            { displayName: "H5", value: "h5" },
            { displayName: "H6", value: "h6" },
        ],
        defaultValue: "h2",
        fieldType: "General",
    },
    customColor: {
        fieldType: "General",
        name: "customColor",
        displayName: "Title Color",
        editorTemplate: "ColorPickerField",
        defaultValue: "rgba(0,0,0,0)",
        isVisible: widget => widget.fields.useCustomColor,
    },
    useCustomColor: {
        name: "useCustomColor",
        displayName: "Use Custom Color",
        editorTemplate: "CheckboxField",
        defaultValue: false,
        fieldType: "General",
    },
};

export default typographyFieldDictionary;
